<!--
  * 페이지 공통 - 검색 컴포넌트
-->
<template>
  <div class="srch-style">
    <input
      type="text"
      name=""
      id=""
      class="srch-style-input"
      :placeholder="this.placeholdered"
      v-model="inputText"
      @keyup.enter="searchData"
    />
    <button type="submit" class="srch-style-btn-srch" @click="searchData">
      검색
    </button>
  </div>
</template>
<script>
export default {
  name: 'SearchBox',
  props: {
    value: {
      // 검색어
      type: String,
      default: '',
    },
    cleanInput: {
      type: Boolean,
      default: false,
    },
    placeholdered: String,
  },
  data() {
    return {
      inputText: this.value, // 검색어
    };
  },
  watch: {
    inputText(newValue) {
      // trim 처리 후, 부모 컴포넌트에게 검색어 전달
      const trimedNewValue = newValue.trim();
      this.inputText = trimedNewValue;
      this.$emit('input', trimedNewValue);
    },
    value() {
      this.inputText = this.value;
    },
  },
  methods: {
    setInputText(value) {
      this.inputText = value;
    },
    searchData() {
      this.$emit('search-data', this.inputText);
      if (this.cleanInput) {
        this.inputText = '';
      }
    },
  },
};
</script>
